import { render, staticRenderFns } from "./DashboardOrder.vue?vue&type=template&id=72009198"
import script from "./DashboardOrder.vue?vue&type=script&lang=js"
export * from "./DashboardOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports